import { styled } from 'ui/styles'
import { ClientCard } from '../ClientCard'
import { Client } from '../../data/clients'
import { FC } from 'react'

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin: 36px 0px;
  @media (max-width: 750px) {
    margin: 24px 0px;
    grid-template-columns: 1fr;
  }
`

interface ListProps {
  items: Client[]
}

export const List: FC<ListProps> = ({ items }) => {
  return (
    <Container>
      {items.map((item) => {
        return <ClientCard key={item.id} item={item} />
      })}
    </Container>
  )
}
